module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reference-avatar",
    style: ({
      backgroundColor: _vm.avatarColor
    })
  }, [_vm._v(_vm._s(_vm.avatarText))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f2820042", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2820042"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/ReferenceAvatar.vue
// module id = 1977
// module chunks = 0